import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'
import classes from '../../List.scss'

export const ListItemColumn = (props) => {
  const className = cx({
    [classes['list-column']]: classes['list-column'],
    [classes['list-column--header']]: !!props.header,
    [classes['list-column--bold']]: !!props.bold && !props.header,
    [classes['list-column--italic']]: !!props.italic && !props.header,
    [classes['list-column--unimportant']]: !!props.unimportant && !props.header,

    [classes['list-column--minimal']]: !!props.minimal,

    [classes['list-column--center']]: !!props.center,
    [classes['list-column--right']]: !!props.right,

    [classes['list-column--success']]: !!props.success && !props.header,
    [classes['list-column--error']]: !!props.error && !props.header,

    [classes['list-column--desktop']]: !!props.desktop,
    [classes['list-column--mobile']]: !!props.mobile
  })

  // purely semantic
  if (props.header) return <th className={className}>{props.children}</th>

  return <td className={className}>{props.children}</td>
}

ListItemColumn.propTypes = {
  children: PropTypes.node,
  header: PropTypes.bool,
  bold: PropTypes.bool,
  italic: PropTypes.bool,
  unimportant: PropTypes.bool,
  minimal: PropTypes.bool,
  center: PropTypes.bool,
  right: PropTypes.bool,
  success: PropTypes.bool,
  error: PropTypes.bool,
  desktop: PropTypes.bool,
  mobile: PropTypes.bool
}

ListItemColumn.defaultProps = {
  bold: false,
  italic: false,
  unimportant: false,
  minimal: false,
  center: false,
  right: false,
  success: false,
  error: false,
  desktop: false,
  mobile: false
}

export default ListItemColumn



// WEBPACK FOOTER //
// ./src/components/List/Item/Column/ListItemColumn.js